import { render, staticRenderFns } from "./Upsell.vue?vue&type=template&id=2fb2d3ab&scoped=true"
import script from "./Upsell.vue?vue&type=script&lang=js"
export * from "./Upsell.vue?vue&type=script&lang=js"
import style0 from "./Upsell.vue?vue&type=style&index=0&id=2fb2d3ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2d3ab",
  null
  
)

export default component.exports